/* eslint-disable */
export const accordion = () => {
	const DLaccordion = document.querySelectorAll('.accordion');
	if (DLaccordion) {
		DLaccordion.forEach(accordion => {
			const accordionTrigger = accordion.querySelectorAll('.accordion-trigger');
			const accordionContent = accordion.querySelectorAll('.accordion-content');
			accordionTrigger.forEach(trigger => {
				trigger.addEventListener('click', function () {
					const target = this.dataset.target;
					const targetContent = accordion.querySelector(`.accordion-content[data-target="${target}"]`);
					const targetTrigger = accordion.querySelector(`.accordion-trigger[data-target="${target}"]`);
					if (targetContent.getAttribute('aria-expanded') === 'true') {
						targetContent.setAttribute('aria-expanded', 'false');
						targetTrigger.setAttribute('aria-expanded', 'false');
						return;
					}
					accordionContent.forEach(content => {
						content.setAttribute('aria-expanded', 'false');
					})
					accordionTrigger.forEach(trigger => {
						trigger.setAttribute('aria-expanded', 'false');
					})
					targetContent.setAttribute('aria-expanded', 'true');
					targetTrigger.setAttribute('aria-expanded', 'true');
				})
			})
		})
	}
}